export default (state = [], action) => {
  switch (action.type){
    case 'SET_CUSTOMERCONFIG':
//        return [...state, Object.assign({}, action.customerConfig)];
		return action.customerConfig;
    default:
          return state;
  }
};